import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ExecutionResponse } from '../../models/support/execution-response';
import { SharedService } from '../other/shared.service';
import { BaseService, BaseServiceSZ } from '../other/baseService';
import { HandleNotifyClientWithOTPModel } from 'src/app/models/classes/transactions/handle-notify-client-with-OTP-model';
@Injectable({
  providedIn: 'root',
})
export class TransactionOTPService extends BaseService {
  private transactionsSecondUrl;

  constructor(
    private http: HttpClient,
    private _BaseService: BaseServiceSZ,
    private sharedService: SharedService
  ) {
    super();
    this.transactionsSecondUrl =
      this.sharedService.ApiUrl + 'TransactionsSecond';
  }

  handleNotifyClientWithOTP(
    model: HandleNotifyClientWithOTPModel
  ): Observable<ExecutionResponse<number>> {
    return this.http
      .post<ExecutionResponse<number>>(
        this.transactionsSecondUrl + '/HandleNotifyClientWithOTP',
        model,
        this.sharedService.getHeaders()
      )
      .pipe(
        tap((res) => {
          this._BaseService.log('HandleNotifyClientWithOTP id=${id}');
          this._BaseService.ValidationResult(res);
        }),

        catchError(
          this._BaseService.handleError<ExecutionResponse<number>>(
            'HandleNotifyClientWithOTP id=${id}'
          )
        )
      );
  }
}
